import React, { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import styled from "styled-components";
import Header from "../../component/organisms/header";
import MainLayout from "../../component/atoms/layout/mainLayout";
import Sidebar from "../../component/organisms/sidebar";
import TableLayout from "../../component/atoms/layout/table/tableLayout";
import TableTitle from "../../component/atoms/text/table/tableTitle";
import TableTop from "../../component/atoms/layout/table/tableTop";
import TableSearchBtn from "../../component/atoms/layout/table/tableSearchBtn";
import TableCount from "../../component/molecules/tableCount";
import SearchBar from "../../component/atoms/input/searchBar";
import Table from "../../component/atoms/layout/table/table";
import Tr from "../../component/atoms/layout/table/tr";
import Checkbox from "../../component/atoms/input/checkbox";
import Th from "../../component/atoms/layout/table/th";
import Td from "../../component/atoms/layout/table/td";
import { toast } from "react-toastify";
import { toastMsg } from "../../util/toastMsg";
import moment from "moment";
import Modal from "../../component/templates/Modal";
import { errorHandler } from "../../util/errorHandler";
import { route } from "../../router/route";
import TableFilterManager from "../../component/atoms/layout/table/tableFilterManager";
import ThText from "../../component/atoms/text/table/thText";
import TdText from "../../component/atoms/text/table/tdText";
import DelBtn from "../../component/atoms/button/delBtn";
import DetailBtn from "../../component/atoms/button/detailBtn";
import PretendardText from "../../component/atoms/text/pretendardText";
import { modalMsg } from "../../util/modalMsg";
import ManagerApi from "../../api/manager.api";
import Pagination from "../../component/molecules/pagination";
import axios from "axios";
import { isNull } from "../../util/check";

function Manager(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [managerList, setManagerList] = useState([]);
  const [keyword, setKeyword] = useState("");
  const isRoot = sessionStorage.getItem("role") === "ROOT";
  const currentAdminId = Number(sessionStorage.getItem("id"));

  // mounted
  useEffect(() => {
    setKeyword(
      isNull(searchParams.get("keyword")) ? "" : searchParams.get("keyword")
    );
    getManagerList();
  }, [location]);

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const getManagerList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
      };
      let responseData = (await ManagerApi.getList(data)).data.data;
      setManagerList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 활성/비활성
  const [filterOpen, setFilterOpen] = useState(-1);
  const [activeId, setActiveId] = useState(null);
  const [activeModalOpen, setActiveModalOpen] = useState(false);
  const [deactiveModalOpen, setDeactiveModalOpen] = useState(false);

  const activeFunc = async (activation) => {
    try {
      const data = {
        activation: activation,
      };
      await ManagerApi.activation(activeId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setActiveModalOpen(false);
      setDeactiveModalOpen(false);
      getManagerList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [delArr, setDelArr] = useState([]);
  const [adminDelModalOpen, setAdminDelModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delArr,
      };

      await ManagerApi.delete(data);
      toast(toastMsg.delete);
      setAdminDelModalOpen(false);
      setDelArr([]);
      getManagerList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 승인
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [approveId, setApproveId] = useState(0);

  const approveFunc = async () => {
    try {
      await ManagerApi.approve(approveId);
      toast("계정이 승인되었습니다.");
      setApproveId(0);
      setApproveModalOpen(false);
      getManagerList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>관리자 권한 관리</TableTitle>
          <TableTop>
            <TableCount
              text={"관리자 (미승인 포함)"}
              count={pagination.totalCount}
            />
            <TableSearchBtn>
              <SearchBar
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(`${route.manager}?page=1&keyword=${encodeURIComponent(keyword)}`, {
                      replace: true,
                    });
                  }
                }}
                onClick={() => {
                  navigate(`${route.manager}?page=1&keyword=${encodeURIComponent(keyword)}`, {
                    replace: true,
                  });
                }}
              />
              {isRoot ? <DelBtn
                text={"선택항목 삭제"}
                onClick={() => {
                  const delList = managerList.filter((item) => item.checked);
                  if (delList.length <= 0) {
                    return;
                  }
                  if (
                    delList.some(
                      (item) => item.rootFlag || item.id === currentAdminId
                    )
                  ) {
                    toast("ROOT 계정 또는 현재 계정은 삭제할 수 없습니다.");
                    return;
                  }

                  setDelArr(delList.map((item) => item.id));
                  setAdminDelModalOpen(true);
                }}
              /> : null}
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              <col width="70px" />
              <col width="196px" />
              <col width="148px" />
              <col width="89px" />
              <col width="147px" />
              <col width="135px" />
              <col width="161px" />
              <col width="77px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={
                      managerList.filter(
                        (item) => !item.rootFlag && item.id !== currentAdminId
                      ).length > 0 &&
                      managerList
                        .filter(
                          (item) => !item.rootFlag && item.id !== currentAdminId
                        )
                        .every((item) => item.checked)
                    }
                    disabled={!isRoot}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setManagerList(
                          managerList.map((item) => {
                            return {
                              ...item,
                              checked:
                                !item.rootFlag && item.id !== currentAdminId,
                            };
                          })
                        );
                      } else {
                        setManagerList(
                          managerList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <ThText>이메일</ThText>
                </Th>
                <Th>
                  <ThText>이름</ThText>
                </Th>
                <Th>
                  <ThText>관리자 유형</ThText>
                </Th>
                <Th>
                  <ThText>등록일</ThText>
                </Th>
                <Th>
                  <ThText>활성화</ThText>
                </Th>
                <Th>
                  <ThText style={{ textAlign: "center", paddingRight: "42px" }}>
                    승인상태
                  </ThText>
                </Th>
                <Th>
                  <ThText style={{ textAlign: "center", paddingRight: "20px" }}>
                    상세보기
                  </ThText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {managerList.map((item, index) => {
                return (
                  <Tr
                    style={{ height: "57px", background: "#fff" }}
                    key={index}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        disabled={
                          !isRoot || item.rootFlag || item.id === currentAdminId
                        }
                        onChange={() => {
                          item.checked = !item.checked;
                          setManagerList([...managerList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TdText
                        style={{
                          width: "170px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          wordBreak: "break-all",
                        }}
                      >
                        {item.email}
                      </TdText>
                    </Td>
                    <Td>
                      <TdText>{item.name}</TdText>
                    </Td>
                    <Td>
                      <TdText>{item.rootFlag ? "ROOT" : "ADMIN"}</TdText>
                    </Td>
                    <Td>
                      <TdText>
                        {moment.utc(item.createdAt).format("YYYY/MM/DD")}
                      </TdText>
                    </Td>
                    <Td>
                      <TableFilterManager
                        onClick={() => {
                          filterOpen === index
                            ? setFilterOpen(-1)
                            : setFilterOpen(index);
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.activation}
                        isApproved={item.approval}
                        disabled={
                          !isRoot || item.rootFlag || item.id === currentAdminId
                        }
                        list={[
                          {
                            value: true,
                            title: "활성",
                            onClick: () => {
                              setActiveId(item.id);
                              setActiveModalOpen(true);
                            },
                          },
                          {
                            value: false,
                            title: "비활성",
                            onClick: () => {
                              setActiveId(item.id);
                              setDeactiveModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          paddingRight: "42px",
                        }}
                      >
                        <TdText
                          style={{
                            color: `${item.approval ? "#262c31" : "#EF594B"}`,
                          }}
                        >
                          {item.approval ? "승인" : "미승인"}
                        </TdText>
                        {item.approval || !isRoot ? null : (
                          <PretendardText
                            style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              color: "#262C31",
                              border: "1px solid #DFE1E4",
                              borderRadius: "4px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "3px 8px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setApproveId(item.id);
                              setApproveModalOpen(true);
                            }}
                          >
                            승인하기
                          </PretendardText>
                        )}
                      </div>
                    </Td>
                    <Td>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingRight: "20px",
                        }}
                      >
                        <DetailBtn
                          onClick={() => {
                            navigate(route.manager_detail + `/${item.id}`);
                          }}
                        />
                      </div>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.manager}
            queryString={`keyword=${searchParams.get("keyword")}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {adminDelModalOpen ? (
        <Modal
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setAdminDelModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : (
        ""
      )}

      {deactiveModalOpen ? (
        <Modal
          title={modalMsg.deactivate?.title}
          setModalOpen={setDeactiveModalOpen}
          onClick={() => {
            activeFunc(false);
          }}
        />
      ) : (
        ""
      )}

      {activeModalOpen ? (
        <Modal
          title={modalMsg.activate?.title}
          setModalOpen={setActiveModalOpen}
          onClick={() => {
            activeFunc(true);
          }}
        />
      ) : (
        ""
      )}

      {approveModalOpen ? (
        <Modal
          title={"계정을 승인하시겠습니까?"}
          btnTitle={"승인하기"}
          setModalOpen={setApproveModalOpen}
          onClick={() => {
            approveFunc();
          }}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Manager;
